import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { OFFER_SERVER_URL } from '../../config';
import { DataWithTranslation, TranslationType } from '../../shared/models/data-with-translations';
import {
	Offer,
} from '../models/product';

import { ProductTranslationService } from './product-translation.service';

const OFFERS_URL = `${ OFFER_SERVER_URL }/offers`;

@Injectable({ providedIn: 'root' })
export class OfferService {
	constructor(
		private readonly http: HttpClient,
		private readonly productTranslationService: ProductTranslationService
	) {}

	getOffer(
		offerId: string,
		withProducts = false,
		translationType?: TranslationType
	) {
		const url = new URL(`${ OFFERS_URL }/${ offerId }`);
		const params = url.searchParams;
		if (withProducts) {
			params.append('characteristics', String(withProducts));
		}
		if (translationType !== undefined) {
			params.append('translation', String(translationType));
		}
		return this.http.get<DataWithTranslation<Offer>>(url.toString()).pipe(map(offer => {
			this.productTranslationService.add(offer.translations);
			return offer.data;
		}));
	}
}
